<template>
  <div
    class="flex flex-col items-center min-h-screen"
    :style="{ 'background-color': branding.backgroundColor }"
    :class="{ 'blur-md pointer-events-none': blocked }"
  >
    <c-image
      v-if="!isInIframe"
      :image-id="coverImage"
      class="h-52 w-full"
      :mode="isMobile ? 'fill' : 'crop'"
    />
    <div class="w-5/6">
      <div
        class="absolute floatting rounded-3xl overflow-hidden m-auto border-2 border-white shadow-md shadow-black"
        :class="{ 'rounded-full': signupPage?.circleLogo }"
        v-if="shouldShowLogo"
      >
        <c-image
          :image-id="branding.logoImageId"
          class="h-48 w-48"
          mode="fit"
        />
      </div>
      <div :class="{ 'mt-32': shouldShowLogo, 'mt-10': !shouldShowLogo }">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<script>
import CImage from "../../../core-ui/src/components/CImage.vue";
import { authStore } from "@/stores/auth";
import { mapState } from "pinia";

export default {
  name: "BrandingShell",
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapState(authStore, ["branding", "signupPage"]),
    shouldShowLogo() {
      return (
        !this.isInIframe && (!this.signupPage || !this.signupPage.hiddenLogo)
      );
    },
    coverImage() {
      if (this.isMobile) {
        return (
          this.branding.signupMobileCoverImageId || this.branding.coverImageId
        );
      } else {
        return (
          this.branding.signupDesktopCoverImageId ||
          this.branding.signupMobileCoverImageId ||
          this.branding.coverImageId
        );
      }
    },
    isMobile() {
      return window.innerWidth < 640;
    },
    isInIframe() {
      return window.self !== window.top;
    },
  },
  components: {
    CImage,
  },
};
</script>
